import * as types from 'actions/actionTypes';
import initialState from '../initialState';

/**
 * reducer per gestire le interrogazioni a crashboxx - download lista excel
 * @param {*} state
 * @param {*} action
 */
export default function crashboxxDownloadListExcelReducer(state = initialState.crashboxxFiles.listExcel, action){

    switch(action.type)
    {
        case types.DOWNLOAD_LISTEXCEL_REQUEST:
            return {...state, error: null, isLoading: true};
        case types.DOWNLOAD_LISTEXCEL_SUCCESS:
            return {...state, error: null, isLoading: false};
        case types.DOWNLOAD_LISTEXCEL_ERROR:
            return {...state, error: action.error, isLoading: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/crashboxx/crashboxxDownloadListExcelReducer.js